import {Component, Vue} from 'vue-property-decorator';

@Component({})
export default class RollMixin extends Vue {
	rollEnter = (element: HTMLElement) => {
		element.style.height = 'auto';
		const height = getComputedStyle(element).height;

		element.style.height = '0';
		getComputedStyle(element).height;

		setTimeout(() => {
			element.style.height = height;
		}, 0);
	};

	rollAfterEnter = (element: HTMLElement) => {
		element.style.height = 'auto';
	};

	rollLeave = (element: HTMLElement) => {
		element.style.height = getComputedStyle(element).height;

		getComputedStyle(element).height;

		setTimeout(() => {
			element.style.height = '0';
		}, 0);
	};
}
